import { useCallback } from 'react';
import { useToastMessageState } from '../../../components/ToastMessage/ToastMessageProvider';
import { BasicFormConfig, IField } from '../../../data-models/field2.data-model';
import { createKPI, getAllKPIs, updateKPI } from '../../../services/queries/KPIConfigQueries';
import { getErrorMessage } from '../../../services/queryHelpers';
import { kpiConfigAtom } from '../../../services/state/KPIConfigState';
import { getForesightStore } from '../../../util/jotai-store';
import { transformKpi } from '../../Config/KPI/ConfigKPI';

export function useKpiConfigActions() {
  const { pushErrorToast, pushSuccessToast } = useToastMessageState();

  return useCallback(
    async (data: Partial<IField<unknown, BasicFormConfig, BasicFormConfig>>) => {
      const action = data.id != undefined ? 'update' : 'create';
      try {
        const payload = transformKpi(data);
        const res =
          action === 'update'
            ? await updateKPI(payload as Parameters<typeof updateKPI>[0])
            : await createKPI(payload);
        const updatedKpis = await getAllKPIs();
        getForesightStore().set(kpiConfigAtom, Promise.resolve(updatedKpis));
        pushSuccessToast({ message: `KPI config ${action} successful` });
        return res;
      } catch (error) {
        pushErrorToast({ message: getErrorMessage(error, `Failed to ${action} KPI config`) });
      }
    },
    [pushErrorToast, pushSuccessToast]
  );
}
